import { connect } from 'react-redux';
import LaporanInvoice from '../../../../views/Finance/Spp/LaporanKeu/LaporanInvoice.laporaninvoice.view';
import { getAdjustmentJournal } from '../../../../states/thunks/finance.thunk';

function mapDispatchToProps(dispatch) {
  return {
    handleGetAdjustmentJournal: payload => dispatch(getAdjustmentJournal(payload)),
  };
}

export default connect(null, mapDispatchToProps)(LaporanInvoice);
